


























import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { patients } from "@/api/mock";
import { Patient } from "@/api/model";

@Component({
  components: {}
})
export default class PatientList extends Vue {
  @Prop({
    required: false,
    type: Array,
    default: () => Object.values(patients)
  })
  public patients!: Array<Patient>;

  selectPatient(id: number) {
    this.$router.push({
      name: "professional-patient",
      params: {
        patientId: id.toString()
      }
    });
  }
}
